"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearWorkspaceAccessControlService = void 0;
var tslib_1 = require("tslib");
var api_1 = require("../../../utils/api");
var GranteeEntryConverter_1 = require("../../../convertors/fromBackend/GranteeEntryConverter");
var BearWorkspaceAccessControlService = /** @class */ (function () {
    function BearWorkspaceAccessControlService(authCall, workspace) {
        this.authCall = authCall;
        this.workspace = workspace;
    }
    BearWorkspaceAccessControlService.prototype.getAccessList = function (sharedObject) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var objectUri, granteesList, items;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_1.objRefToUri(sharedObject, this.workspace, this.authCall)];
                    case 1:
                        objectUri = _a.sent();
                        return [4 /*yield*/, this.authCall(function (sdk) { return sdk.project.getGranteesInfo(objectUri, {}); })];
                    case 2:
                        granteesList = _a.sent();
                        items = granteesList.grantees.items;
                        return [2 /*return*/, items.map(GranteeEntryConverter_1.convertGranteeEntry)];
                }
            });
        });
    };
    BearWorkspaceAccessControlService.prototype.grantAccess = function (sharedObject, grantees) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var objectUri, granteeUris;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_1.objRefToUri(sharedObject, this.workspace, this.authCall)];
                    case 1:
                        objectUri = _a.sent();
                        return [4 /*yield*/, Promise.all(grantees.map(function (grantee) { return api_1.objRefToUri(grantee.granteeRef, _this.workspace, _this.authCall); }))];
                    case 2:
                        granteeUris = _a.sent();
                        return [2 /*return*/, this.authCall(function (sdk) { return sdk.project.addGrantees(objectUri, granteeUris); })];
                }
            });
        });
    };
    BearWorkspaceAccessControlService.prototype.revokeAccess = function (sharedObject, grantees) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var objectUri, granteeUris;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_1.objRefToUri(sharedObject, this.workspace, this.authCall)];
                    case 1:
                        objectUri = _a.sent();
                        return [4 /*yield*/, Promise.all(grantees.map(function (grantee) { return api_1.objRefToUri(grantee.granteeRef, _this.workspace, _this.authCall); }))];
                    case 2:
                        granteeUris = _a.sent();
                        return [2 /*return*/, this.authCall(function (sdk) { return sdk.project.removeGrantees(objectUri, granteeUris); })];
                }
            });
        });
    };
    return BearWorkspaceAccessControlService;
}());
exports.BearWorkspaceAccessControlService = BearWorkspaceAccessControlService;
//# sourceMappingURL=index.js.map